export default "__VITE_ASSET__DyLyR2Yr__"